<template>
  <b-modal size="xl" v-model="showModalMap" id="modal-map" centered
           body-class="my-body" hide-footer hide-header @hidden="hide">
    <b-row style=" flex-grow : 1; margin-bottom: 0px" :class="{ hidden: true, 'show-hidden': !isHidden }">
      <b-col style="height: 600px; padding: 0; margin-bottom: 0; overflow: hidden" id="map_container_modal"
             ref="map_container_modal">
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import ZoomControl from 'mapbox-gl-controls/lib/zoom';
import LanguageControl from 'mapbox-gl-controls/lib/language';
import mapboxgl from 'mapbox-gl/dist/mapbox-gl';
import TaskMapPopup from "@/views/aufgaben_verwaltung/TaskMapPopup.vue";
import ClearIcon from 'vue-material-design-icons/CloseCircle.vue';
import StylesControl from 'mapbox-gl-controls/lib/styles';


import Vue from 'vue';



export default {
  name: "TaskLocationMap",
  components: {
    ClearIcon,
  },
  props : {
    lat: {
      type: Number,
      default: 0.0
    },
    lon: {
      type: Number,
      default: 0.0
    },
    geoRefPerimeter: {
      type: String,
      default: "",
    }
  },
  data() {
    return {
      _lat: 0.0,
      _lon: 0.0,
      showModalMap: false,
      isHidden: true,
      closeToggle: new class {
        constructor(parent) {
          this.parent = parent;
        }

        onAdd(map) {
          this.map = map;
          this.container = document.createElement('div');
          this.container.className = 'mapboxgl-ctrl mapboxgl-ctrl-group mapboxgl-ctrl-styles';
          this.button = document.createElement('button');
          this.button.innerHTML = "&#x2715; Schließen";
          this.button.onclick = this.parent.closeMap;
          this.container.appendChild(this.button);
          return this.container;
        }

        onRemove() {
          this.container.parentNode.removeChild(this.container);
          this.map = undefined;
        }
      }(this),
      saveToggle: new class {
        constructor(parent) {
          this.parent = parent;
        }

        onAdd(map) {
          this.map = map;
          this.container = document.createElement('div');
          this.container.className = 'mapboxgl-ctrl mapboxgl-ctrl-group mapboxgl-ctrl-styles';
          this.button = document.createElement('button');
          this.button.innerHTML = "💾 Speichern";
          this.container.style.background = 'green';
          this.button.style.color = 'white';
          this.button.onclick = this.parent.saveMap;
          this.container.appendChild(this.button);
          return this.container;
        }

        onRemove() {
          this.container.parentNode.removeChild(this.container);
          this.map = undefined;
        }
      }(this),
    }
  },
  methods: {
    hide() {
      if (this.marker !== null) {
        this.marker.remove();
        this.marker = null;
      }
      if (this.map !== null) {
        this.map.remove();
        this.map = null;
      }
    },
    closeMap() {
      this.showModalMap = false;
      this.map = null;
    },
    saveMap() {
      this.showModalMap = false;
      this.map = null;
      this.$emit('save-position', {lat: this._lat, lon: this._lon})
    },
    showMapIfNeeded() {
      let bounds = new (mapboxgl.LngLatBounds);
      let zoom = 16;
      let center = undefined;
      if (this.lat !== 0.0 && this.lon !== 0.0) {
        bounds.extend([this.lon, this.lat]);
      } else if (this.geoRefPerimeter !== "") {
        let sw = this.geoRefPerimeter.split("||")[0].split(",");
        let ne = this.geoRefPerimeter.split("||")[1].split(",");
        bounds = new mapboxgl.LngLatBounds([parseFloat(sw[0]), parseFloat(sw[1])], // southwestern corner of the bounds
            [parseFloat(ne[0]), parseFloat(ne[1])])
        zoom = 12;
      } else {
        bounds = undefined;
        zoom = 6;
        center = [10.244990, 50.943359];
      }
      mapboxgl.accessToken = 'pk.eyJ1Ijoic3ZlbnBldGVyc2VuIiwiYSI6ImNqc3Z0YW82dDBhbDE0NXFpOGRzOXI4NWsifQ.Sq1nJiC3uKfA5yfYN8wR9w';
      this.map = new mapboxgl.Map({
        container: 'map_container_modal',
        style: 'mapbox://styles/mapbox/outdoors-v11',
        bounds: bounds,
        center: center,
        zoom: zoom,
        minZoom: 5,
        maxPitch: 0,
        attributionControl: false
      });

      this.map.addControl(this.saveToggle, 'bottom-right');
      this.map.addControl(new ZoomControl(), 'bottom-right');
      this.map.addControl(this.closeToggle, 'top-right');
      const languageControl = new LanguageControl({
        language: 'de',
      });
      this.map.addControl(languageControl);

      this.marker = null;
      this.map.on('load', this.mapLoad);
      this.map.on('click', this.onMapClick);
    },
    onMapClick(e) {
      this._lat = e.lngLat.lat;
      this._lon = e.lngLat.lng;

      if (this.marker === null) {
        let el = document.createElement('div');
        el.className = 'marker';

        this.marker = new mapboxgl.Marker({
          element: el,
          anchor: 'center',
        })
            .setLngLat([this._lon, this._lat])
            .addTo(this.map);
      } else {
        this.marker.setLngLat([this._lon, this._lat])
      }
    },
    mapLoad() {
      setTimeout(() => {
        if (this.lat !== 0.0 && this.lon !== 0.0) {
          let el = document.createElement('div');
          el.className = 'marker';

          this.marker = new mapboxgl.Marker({
            element: el,
            anchor: 'center',
          })
              .setLngLat([this.lon, this.lat])
              .addTo(this.map);
        }
        this.map.resize();
        this.isHidden = false;
      });
    },
    showMap() {
      this.isHidden = true;
      this.marker = null;
      this._lon = this.lon;
      this._lat = this.lat;
      this.showModalMap = true;
      this.$nextTick(() => {
        this.showMapIfNeeded();
      });
    },
  }
}
</script>

<style scoped>
.hoverable-icon:hover {
  cursor: pointer;
}
</style>

<style>
.black {
  color: black;
}
.mapboxgl-popup {
  max-width: 600px !important;
  z-index: 2;
}
.mapboxgl-popup-close-button {
  font-size: 20px;
}

.marker {
  background-image: url('../../../../public/mangel_marker.png');
  background-size: cover;
  width: 35px;
  height: 35px;
  border-radius: 50%;
  cursor: pointer;
  z-index: 1;
}

.marker_selected {
  background-image: url('../../../../public/mangel_marker.png');
  background-size: cover;
  width: 37px;
  height: 37px;
  border-radius: 50%;
  cursor: pointer;
  z-index: 1;
}

.my-body {
  padding: 0 !important;
}

.hidden {
  opacity: 0;
  transition: opacity 0.1s ease-in;
}

.mapboxgl-popup-close-button {
  outline: none !important;
}

.show-hidden {
  opacity: 1;
}


.sidebar2 {
  visibility: hidden;
  width: 0;
  position: absolute;
  z-index: 1 !important;
  overflow-x: hidden;
  -webkit-transition: 0.5s;
  transition: 0.5s;
  -moz-transition: 0.5s;
  padding: 0;
  top: 50px;
  -webkit-transition-property: width, visibility;
  transition-property: width, visibility;
  -moz-transition-property: width, visibility;
  -webkit-transition-timing-function: ease;
  transition-timing-function: ease;
  -moz-transition-timing-function: ease;
}

.mapboxgl-ctrl-top-left {
  display: flex;
  display: flex;
  display: -moz-flex;
  display: -webkit-flex;
  display: -o-flex;
}

.mapboxgl-ctrl-top-left .mapboxgl-ctrl {
  display: flex;
  display: flex;
  display: -moz-flex;
  display: -webkit-flex;
  display: -o-flex;
}
.mapboxgl-ctrl-top-left .mapboxgl-ctrl-group button+button {
  border-left: 1px solid #ddd;
  border-top: none;
}

.my-custom-control {
  color: #f00;
  background: #000;
  padding: 8px;
  border-radius: 4px;
  margin: 8px;
}

</style>
